var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "books_bg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 610 947",
    style: {
      enableBackground: "new 0 0 610 947"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -135.3,
    y: -0.1,
    width: 1141.1,
    height: 947.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2_1_",
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57_1_",
    transform: "translate(-2443.92 512.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106_1_",
    style: {
      fill: "#EAEAEA"
    },
    d: "M3010.1,259.9h-514.5l178.3-1001.2h157.9L3010.1,259.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128_1_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M2752.9,168c142.1,0,257.3,43,257.3,96.1s-115.2,96.1-257.3,96.1 s-257.3-43-257.3-96.1S2610.8,168,2752.9,168z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_56_1_",
    transform: "translate(2703.386 -23.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107_1_",
    style: {
      fill: "#B03C2C"
    },
    d: "M28.4,261.7l-100.3,23.9c-11.4-0.1-22.1-3-23.3-7.8V114.4L5.2,90.4V99l23.3-0.7 L28.4,261.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108_1_",
    style: {
      fill: "#782E29"
    },
    d: "M-71.9,285.6L-71.9,285.6l0-171.2h-23.3v163.4C-94,282.6-83.3,285.5-71.9,285.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109_1_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M-94.8,115.4L4.7,91.6c1.1,4.9,12.3,6.5,23.8,6.6l-100.3,23.9 C-82.5,122.1-92.5,119.6-94.8,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110_1_",
    style: {
      fill: "#B03C2C"
    },
    d: "M55.2,270.8l-100.3,23.9c-11.4-0.1-22.1-3-23.3-7.8V123.5L32,99.6v8.6l23.3-0.7 L55.2,270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111_1_",
    style: {
      fill: "#782E29"
    },
    d: "M-45.1,294.7L-45.1,294.7l0-171.2h-23.3v163.4 C-67.2,291.8-56.5,294.6-45.1,294.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112_1_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M-68,124.5l99.5-23.7c1.1,4.9,12.3,6.5,23.8,6.6l-100.3,23.9 C-55.7,131.2-65.7,128.8-68,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113_1_",
    style: {
      fill: "#B03C2C"
    },
    d: "M82,279.9l-100.3,23.9c-11.4-0.1-22.1-3-23.3-7.8V132.6l100.3-23.9v8.6 l23.3-0.7L82,279.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114_1_",
    style: {
      fill: "#782E29"
    },
    d: "M-18.3,303.8L-18.3,303.8l0-171.2h-23.3V296C-40.4,300.9-29.7,303.7-18.3,303.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115_1_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M-41.2,133.6l99.5-23.7c1.1,4.9,12.3,6.5,23.8,6.6l-100.3,23.9 C-28.9,140.4-38.9,137.9-41.2,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116_1_",
    style: {
      fill: "#B03C2C"
    },
    d: "M108.8,289L8.5,313c-11.4-0.1-22.1-3-23.3-7.8V141.7l100.3-23.9v8.6l23.3-0.7 V289z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117_1_",
    style: {
      fill: "#782E29"
    },
    d: "M8.5,313L8.5,313l0-171.2h-23.3v163.4C-13.6,310-2.9,312.8,8.5,313z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118_1_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M-14.4,142.7L85.1,119c1.1,4.9,12.3,6.5,23.8,6.6L8.5,149.6 C-2.1,149.5-12.1,147-14.4,142.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119_1_",
    style: {
      fill: "#B03C2C"
    },
    d: "M135.6,298.1L35.3,322.1c-11.4-0.1-22.1-3-23.3-7.8V150.9l100.3-23.9v8.6 l23.3-0.7V298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120_1_",
    style: {
      fill: "#782E29"
    },
    d: "M35.3,322.1L35.3,322.1l0-171.2H12v163.4C13.2,319.1,23.9,322,35.3,322.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121_1_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M12.4,151.9l99.5-23.7c1.1,4.9,12.3,6.5,23.8,6.6L35.3,158.7 C24.7,158.6,14.7,156.1,12.4,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122_1_",
    style: {
      fill: "#B03C2C"
    },
    d: "M162.4,307.3L62.1,331.2c-11.4-0.1-22.1-3-23.3-7.8V160L139.1,136v8.6l23.3-0.7 V307.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123_1_",
    style: {
      fill: "#782E29"
    },
    d: "M62.1,331.2L62.1,331.2l0-171.2H38.8v163.4C39.9,328.2,50.6,331.1,62.1,331.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124_1_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.2,161l99.5-23.7c1.1,4.9,12.3,6.5,23.8,6.6L62.1,167.8 C51.5,167.7,41.5,165.2,39.2,161z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125_1_",
    style: {
      fill: "#B03C2C"
    },
    d: "M189.2,316.4L88.9,340.3c-11.4-0.1-22.1-3-23.3-7.8V169.1l100.3-23.9v8.6 l23.3-0.7V316.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126_1_",
    style: {
      fill: "#782E29"
    },
    d: "M88.9,340.3L88.9,340.3l0-171.2H65.6v163.4C66.7,337.4,77.4,340.2,88.9,340.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127_1_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M66,170.1l99.5-23.7c1.1,4.9,12.3,6.5,23.8,6.6L88.9,176.9 C78.2,176.8,68.2,174.4,66,170.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.4a956d57802dd2bd15925833cfe2ae7a.svg";
export { ForwardRef as ReactComponent };